export const KitchenReportPagination = ({ pageLength, currentPage, handleNumber }) => {
    const total = pageLength.length;

    const getPages = () => {
        if (total <= 7) return pageLength;
        if (currentPage <= 4) return [1, 2, 3, 4, 5, '…', total];
        if (currentPage >= total - 3) return [1, '…', total - 4, total - 3, total - 2, total - 1, total];
        return [1, '…', currentPage - 1, currentPage, currentPage + 1, '…', total];
    };

    const base = `
        h-9 min-w-[36px] px-2.5 rounded-lg border text-sm font-medium
        inline-flex items-center justify-center gap-1
        transition-all duration-150 active:scale-95
    `;
    const inactive = `bg-white border-[#E0DDD8] text-[#5A5854] hover:bg-[#F3F1EC] hover:border-[#C8C3BB]`;
    const active = `bg-[#2C2C2A] border-[#2C2C2A] text-[#F8F7F3]`;
    const disabled = `bg-white border-[#E0DDD8] text-[#C8C3BB] cursor-not-allowed opacity-50`;

    if (total === 0) {
        return (
            <div className="text-center">
                <div className="inline-flex items-center rounded-md border font-semibold border-[#E0DDD8] bg-[#FAFAF8] px-4 py-2 text-sm text-[#807e76]">
                    No pages available
                </div>
            </div>
        );
    }

    return (
        <div className="flex flex-col items-center gap-2 pt-6">
            <div className="flex flex-wrap items-center justify-center gap-1">

                {/* Prev */}
                <button
                    type="button"
                    onClick={() => handleNumber(currentPage - 1)}
                    disabled={currentPage === 1}
                    className={`${base} ${currentPage === 1 ? disabled : inactive}`}
                    aria-label="Previous page"
                >
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" className="shrink-0">
                        <path d="M10 12L6 8l4-4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                    <span className="hidden sm:inline text-xs">Prev</span>
                </button>

                {/* Pages */}
                {getPages().map((page, i) =>
                    page === '…' ? (
                        <span key={`ellipsis-${i}`} className="h-9 min-w-[36px] flex items-center justify-center text-[#9E9990] text-sm tracking-widest select-none">
                            ···
                        </span>
                    ) : (
                        <button
                            key={page}
                            type="button"
                            onClick={() => handleNumber(page)}
                            aria-current={currentPage === page ? 'page' : undefined}
                            className={`${base} ${currentPage === page ? active : inactive}`}
                        >
                            {page}
                        </button>
                    )
                )}

                {/* Next */}
                <button
                    type="button"
                    onClick={() => handleNumber(currentPage + 1)}
                    disabled={currentPage === total}
                    className={`${base} ${currentPage === total ? disabled : inactive}`}
                    aria-label="Next page"
                >
                    <span className="hidden sm:inline text-xs">Next</span>
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" className="shrink-0">
                        <path d="M6 4l4 4-4 4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                </button>
            </div>

            {/* Page counter */}
            <div className="text-xs text-[#7a7770] font-medium">
                Page {currentPage} of {total}
            </div>
        </div>
    );
};